export const prefix = 'serpent';

export const getClassName = (className: string, clsPrefix: string) => {
  return `${clsPrefix}-${className}`;
};
